import {
  Setup,
  Magnifier,
  Awareness,
  GentleReturn,
  TimeWeight,
  SetupNew,
  FocusNew,
  AwarenessNew,
  GentleNew,
  DurationNew,
} from "@utils/defaultImages";

export const getMindfulnessStepsData = ({ mindfulnessStepsData, t }) => {
  return [
    {
      bg: SetupNew,
      label: t("Setup"),
      key: "setup",
      icon: <Setup className="min-w-7 min-h-7" />,
      tabColor: "#F0FFFF",
      value: mindfulnessStepsData?.setup,
      model_value:
        mindfulnessStepsData?.setup_detail ?? mindfulnessStepsData?.setup,
    },
    {
      bg: FocusNew,
      label: t("Focus"),
      key: "focus",
      icon: <Magnifier className="min-w-7 min-h-7" />,
      tabColor: "#F0FFFF",
      value: mindfulnessStepsData?.focus,
      model_value:
        mindfulnessStepsData?.focus_detail ?? mindfulnessStepsData?.focus,
    },
    {
      bg: AwarenessNew,
      label: t("Awareness"),
      key: "awareness",
      icon: <Awareness className="min-w-7 min-h-7" />,
      tabColor: "#F0FFFF",
      value: mindfulnessStepsData?.awareness,
      model_value:
        mindfulnessStepsData?.awareness_detail ??
        mindfulnessStepsData?.awareness,
    },
    {
      bg: GentleNew,
      label: t("Gentle Return"),
      key: "gentle_return",
      icon: <GentleReturn className="min-w-7 min-h-7" />,
      tabColor: "#FFF0FB",
      value: mindfulnessStepsData?.gentle_return,
      model_value:
        mindfulnessStepsData?.gentle_return_detail ??
        mindfulnessStepsData?.gentle_return,
    },
    {
      bg: DurationNew,
      label: t("Duration"),
      key: "duration",
      icon: <TimeWeight className="min-w-7 min-h-7" />,
      tabColor: "#FFF0FF",
      value: mindfulnessStepsData?.duration,
      model_value:
        mindfulnessStepsData?.duration_detail ?? mindfulnessStepsData?.duration,
    },
  ];
};
